// Simple logger that is silent in production builds
// Relies on Vite define constants: __DEV__ and __PROD__

type LogMethod = (...args: unknown[]) => void

const noop: LogMethod = () => {}

type GlobalWithDevFlag = typeof globalThis & { __DEV__?: boolean }

const dev = (globalThis as GlobalWithDevFlag).__DEV__ === true || import.meta.env?.DEV === true
const isTest = import.meta.env?.MODE === 'test'
const verbose = dev && !isTest

export const logger = {
  log: verbose ? console.log.bind(console) : noop,
  warn: verbose ? console.warn.bind(console) : noop,
  error: console.error.bind(console), // always surface errors
}
